import { render, staticRenderFns } from "./AudioPlayerComponent.vue?vue&type=template&id=9889650e&scoped=true"
import script from "./AudioPlayerComponent.vue?vue&type=script&lang=js"
export * from "./AudioPlayerComponent.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayerComponent.vue?vue&type=style&index=0&id=9889650e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9889650e",
  null
  
)

export default component.exports